export default __webpack_public_path__ + "static/mode-paired-dark-2488fb1af0a62158c10ba66fedca8e10.png";